exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top-toolbar[data-v-6cfc44d7] {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e8e8e8;\n  margin-bottom: 8px;\n}\n.hiprint-container[data-v-6cfc44d7] {\n  min-height: 400px;\n}\n.preview-wrapper[data-v-6cfc44d7] {\n  overflow: auto;\n  text-align: center;\n}\n.no-template[data-v-6cfc44d7] {\n  padding: 80px 0;\n}\n.designer-wrapper[data-v-6cfc44d7] {\n  height: calc(100% - 20px);\n}\n", ""]);

// exports
